import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChevronRight32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 24c0 .562.406 1 1 1 .25 0 .5-.094.719-.282l8-8a1.1 1.1 0 0 0 .281-.718c0-.25-.094-.5-.281-.719l-8-8a1.101 1.101 0 0 0 -.719-.281c-.25 0-.5.094-.719.281a1.1 1.1 0 0 0 -.28.72c0 .249.093.499.28.718l7.313 7.28-7.313 7.282a1.102 1.102 0 0 0 -.281.719z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChevronRight32;
